export const DATA_FIRESTORE_V01_COMPETITOR_ACCOUNT = {
  NAME: 'v01_competitor_accounts',
  FIELDS: {
    VERSION: {
      KEY: 'v',
      DEFAULT: 1,
    },
  },
}
